<template>
    <div :class="[`m-pagination ${placement}`, { hidden: hideOnSinglePage && total <= pageSize }]">
        <div class="m-pagination-wrap">
            <span class="mr8" v-if="showTotal">共 {{ totalPage }} 页 / {{ total }} 条</span>
            <span class="u-item left-item" :class="{ disabled: currentPage === 1 }" @click="changePage(currentPage - 1)"></span>
            <span :class="['u-item', { active: currentPage === 1 }]" @click="changePage(1)">1</span>
            <span class="m-arrow" ref="forward" v-show="forwardMore && pageList[0] - 1 > 1" @click="onForward">
                <span v-show="!forwardArrow" class="u-ellipsis">...</span>
            </span>
            <span :class="['u-item', { active: currentPage === page }]" v-for="(page, index) in pageList" :key="index" @click="changePage(page)">{{ page }}</span>
            <span class="m-arrow" ref="backward" v-show="backwardMore && pageList[pageList.length - 1] + 1 < totalPage" @click="onBackward">
                <span v-show="!backwardArrow" class="u-ellipsis">...</span>
            </span>
            <span v-show="totalPage !== 1" :class="['u-item', { active: currentPage === totalPage }]" @click="changePage(totalPage)">{{ totalPage }}</span>
            <span class="u-item right-item" :class="{ disabled: currentPage === totalPage }" @click="changePage(currentPage + 1)"></span>
            <span class="u-jump-page" v-if="showQuickJumper">
                <i>跳转至</i>
                <input type="text" v-model="jumpNumber" oninput="value=value.replace(/\D/g, '')" @blur="inputBlur" />
                <i>页</i>
                <i class="go-page">GO</i>
            </span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Page',
    props: {
        // 当前页数
        current: {
            type: Number,
            default: 1
        },
        // 每页条数
        pageSize: {
            type: Number,
            default: 10
        },
        // 数据总数
        total: {
            type: Number,
            default: 0
        },
        // 显示的页码数组长度
        pageListNum: {
            type: Number,
            default: 5
        },
        // 只有一页时是否隐藏分页器
        hideOnSinglePage: {
            type: Boolean,
            default: false
        },
        // 是否可以快速跳转至某页
        showQuickJumper: {
            type: Boolean,
            default: false
        },
        // 是否显示当前页数和数据总量
        showTotal: {
            type: Boolean,
            default: false
        },
        // 分页器展示位置，靠左left，居中center，靠右right
        placement: {
            type: String,
            default: 'right'
        }
    },
    data() {
        return {
            currentPage: this.current, // 当前页数
            jumpNumber: 1, // 跳转的页码
            forwardMore: false, // 左省略号展示
            backwardMore: false, // 右省略号展示
            forwardArrow: false, // 左箭头展示
            backwardArrow: false // 右箭头展示
        }
    },
    computed: {
        totalPage() {
            return Math.ceil(this.total / this.pageSize)
        },
        pageList() {
            return this.dealPageList(this.currentPage).filter(n => n !== 1 && n !== this.totalPage)
        }
    },
    watch: {
        current(to) {
            this.currentPage = to
        },
        currentPage(to) {
            // 通过更改当前页码，修改分页数据
            this.loading = true
            this.jumpNumber = to
            this.$emit('change', {
                page: to,
                pageSize: this.pageSize
            })
        }
    },
    created() {
        // 监听键盘Enter按键
        document.onkeydown = e => {
            const ev = e || window.event
            if (ev && ev.keyCode === 13 && this.jumpNumber) {
                this.jumpNumber = parseInt(this.jumpNumber) == 0 ? 1 : parseInt(this.jumpNumber)
                this.jumpNumber = this.jumpNumber > this.totalPage ? this.totalPage : this.jumpNumber
                this.jumpPage(this.jumpNumber)
            }
        }
    },
    methods: {
        dealPageList(curPage) {
            var resList = []
            var offset = Math.floor(this.pageListNum / 2) // 向下取整
            var pager = {
                start: curPage - offset,
                end: curPage + offset
            }
            if (pager.start < 1) {
                pager.end = pager.end + (1 - pager.start)
                pager.start = 1
            }
            if (pager.end > this.totalPage) {
                pager.start = pager.start - (pager.end - this.totalPage)
                pager.end = this.totalPage
            }
            if (pager.start < 1) {
                pager.start = 1
            }
            if (pager.start > 1) {
                this.forwardMore = true
            } else {
                this.forwardMore = false
            }
            if (pager.end < this.totalPage) {
                this.backwardMore = true
            } else {
                this.backwardMore = false
            }
            // 生成要显示的页码数组
            for (let i = pager.start; i <= pager.end; i++) {
                resList.push(i)
            }
            return resList
        },
        onForward() {
            this.currentPage = this.currentPage - this.pageListNum > 0 ? this.currentPage - this.pageListNum : 1
        },
        onBackward() {
            this.currentPage = this.currentPage + this.pageListNum < this.totalPage ? this.currentPage + this.pageListNum : this.totalPage
        },
        jumpPage(jumpNum) {
            if (Number(jumpNum)) {
                if (Number(jumpNum) < 1) {
                    jumpNum = 1
                }
                if (Number(jumpNum) > this.totalPage) {
                    jumpNum = this.totalPage
                }
                this.changePage(Number(jumpNum))
            }
        },
        changePage(pageNum) {
            if (pageNum === 0 || pageNum === this.totalPage + 1) {
                return false
            }
            if (this.currentPage !== pageNum) {
                // 点击的页码不是当前页码
                this.currentPage = pageNum
            }
        },
        inputBlur(e) {
            if (this.jumpNumber) {
                this.jumpNumber = parseInt(this.jumpNumber) == 0 ? 1 : parseInt(this.jumpNumber)
                this.jumpNumber = this.jumpNumber > this.totalPage ? this.totalPage : this.jumpNumber
                this.jumpPage(this.jumpNumber)
            } else {
                this.jumpNumber = this.currentPage
            }
        }
    }
}
</script>
<style lang="less" scoped>
.hidden {
    display: none;
}

.left {
    text-align: left;
}

.center {
    text-align: center;
}

.right {
    text-align: right;
}

.m-pagination-wrap {
    display: inline-block;
    line-height: 24px;
    font-size: 14px;
    text-align: center;

    .mr8 {
        margin-right: 8px;
    }

    .u-item {
        display: inline-block;
        min-width: 36px;
        text-align: center;
        height: 36px;
        line-height: 36px;
        vertical-align: middle;
        border-radius: 18px;
        cursor: pointer;
        transition: all 0.3s;
        background: #272729;
        color: #999999;

        &:hover {
            color: #fff;
        }

        &.left-item {
            background-image: url(../assets/left-arr.png);
            background-size: 8px 13px;
            background-position: center;
            background-repeat: no-repeat;

            &:hover {
                background-image: url(../assets/left-arr-active.png);
            }
        }

        &.right-item {
            background-image: url(../assets/right-arr.png);
            background-size: 8px 13px;
            background-position: center;
            background-repeat: no-repeat;

            &:hover {
                background-image: url(../assets/right-arr-active.png);
            }
        }

        .u-arrow {
            width: 12px;
            height: 12px;
            transition: all 0.3s;
        }

        &:not(:last-child) {
            margin-right: 8px;
        }
    }

    .active {
        color: #fff;
        background-color: #4e4f54;
    }

    .disabled {
        cursor: not-allowed;
    }

    .m-arrow {
        display: inline-block;
        vertical-align: middle;
        margin-right: 8px;
        width: 24px;
        height: 24px;
        border-radius: 2px;
        background: #222322;
        transition: all 0.3s;
        cursor: pointer;

        .u-ellipsis {
            transition: all 0.3s;
            font-weight: bold;
            color: #fff;
            position: relative;
            top: -3px;
            user-select: none;
        }
    }

    .u-jump-page {
        color: #999999;
        font-size: 0;
        position: relative;
        top: -4px;
        left: 5px;
        user-select: none;

        i,
        input {
            vertical-align: middle;
            font-size: 14px;
            margin-right: 4px;
            line-height: 22px;
        }

        i {
            font-style: normal;
            position: relative;

            &.go-page {
                border-radius: 4px;
                position: relative;
                display: inline-block;
                background: #272729;
                text-align: center;
                padding: 1px 5px;
                cursor: pointer;
                margin-right: 0;
            }
        }

        input {
            width: 48px;
            height: 24px;
            text-align: center;
            border-radius: 4px;
            background: #272729;
            color: #999999;
            outline: none;
            border: none;
            transition: all 0.3s;
            position: relative;
        }
    }
}
</style>
